<template>
  <div class="dropdownDoc">
    <documentation-container :title="title">
      <template slot="content">
        <div class="dropdown-layout">
            <adx-multiple-dropdown :list="multiple" :title="`More Filter`">
            </adx-multiple-dropdown>
        </div>
      </template>
    </documentation-container>
  </div>
</template>

<script>
import MultipleDropdown from '@/components/Dropdown/MultipleDropdown'

import DocumentationContainer from '@/components/DocumentationContainer'


export default {
  name: 'adx-multiple-dropdown-doc',
  components: {
    'documentation-container': DocumentationContainer,
    'adx-multiple-dropdown': MultipleDropdown,
  },
  data() {
    return {
      title: 'Multiple Dropdown',
      multiple: [
          {
              type: 'list',
              title: 'Brands',
              list: [
                {
                'id': 0,
                'label': 'Gaul',
                'value': 'GA',
                },
                {
                'id': 1,
                'label': 'Jadul',
                'value': 'JA'
                },
                {
                'id': 2,
                'label': 'Konser',
                'value': 'KO'
                },
                {
                'id': 3,
                'label': 'Nobar',
                'value': 'NO'
                },
                {
                'id': 4,
                'label': 'Seminar',
                'value': 'SE'
                }
              ]
          },
          {
              type: 'checkbox',
              title: 'Social',
              list: [
                {
                'id': 0,
                'label': 'Bebek Kaleyo',
                'value': 'BK',
                },
                {
                'id': 1,
                'label': 'Laus Kopi',
                'value': 'LK'
                },
                {
                'id': 2,
                'label': 'Upnormal',
                'value': 'UP'
                },
                {
                'id': 3,
                'label': 'Abuba',
                'value': 'AB'
                },
                {
                'id': 4,
                'label': 'Concordia',
                'value': 'CO'
                }
              ]
          }
      ]
    }
  },
  methods: {

  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>